let hiddenDownloadFrame: HTMLIFrameElement | null = null;

const FRAME_STYLE =
  "position:fixed;inset:0;width:0;height:0;border:0;clip:rect(0,0,0,0);overflow:hidden;visibility:hidden;pointer-events:none";

export function startDownloadViaHiddenFrame(url: string): void {
  if (!hiddenDownloadFrame || !document.body.contains(hiddenDownloadFrame)) {
    hiddenDownloadFrame = document.createElement("iframe");
    hiddenDownloadFrame.setAttribute("aria-hidden", "true");
    hiddenDownloadFrame.setAttribute("tabindex", "-1");
    hiddenDownloadFrame.title = "Download";
    hiddenDownloadFrame.style.cssText = FRAME_STYLE;
    document.body.appendChild(hiddenDownloadFrame);
  }
  hiddenDownloadFrame.src = url;
}
